import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    },
    typography: {
        fontFamily: `Open Sans, sans-serif`,
        fontSize: 16,
        letterSpacing: 'normal',
    },
    palette: {
        primary: {
            main: '#db0022',
        },
        secondary: {
            main: '#104057',
        },
        grey: {
            50: '#dddddd',
        },
        background: {
            default: '#fff'
        },
        text: {
            primary: '#104057',
        }
    },
    link: {
        textDecorationStyle: 'none'
    }
});

theme.overrides = {
    MuiPaper: {
        root: {
            minHeight: 520
        },
        elevation1: {
            boxShadow: 'none'
        }
    },
    MuiLink: {
        root: {
            color: theme.palette.primary.main,
        }
    },
    MuiButton: {
        contained: {
            width: '100%',
            maxWidth: 260,
            position: 'relative',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            lineHeight: '1.5',
            borderRadius: 8,
            boxShadow: 'none',
            padding: '12px 16px',
            textTransform: 'capitalize',
            border: `1px solid ${theme.palette.primary.main}`,
            zIndex: 0,
            overflow: 'hidden',
            transition: 'background-color .35s, color .35s',
            '&:before': {
                content: '""',
                backgroundColor: 'white',
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                zIndex: -1,
                transformOrigin: 'right 50%',
                transform: 'scaleX(0)',
                transition: 'transform .35s',
            },
            '&:hover': {
                // backgroundColor: 'white',
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                boxShadow: 'none',
                '&:before': {
                    transformOrigin: 'left 50%',
                    transform: 'scaleX(1)',
                }
            },
        }
    },
    MuiInput: {
        underline: {
            '&:before': {
                borderBottomColor: theme.palette.grey[50],
            },
            '&:after': {
                borderBottomColor: theme.palette.grey[50],
            },
            '&:hover:not($disabled):before': {
                borderBottomColor: theme.palette.secondary.main,
            },
        },
        root: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiInputLabel: {
        animated: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiTableCell: {
        head: {
            fontStyle: 'italic',
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
        root: {
            borderBottom: `1px solid ${theme.palette.primary.main}`,
            padding: 13,
            height: 41
        }
    },
    MuiTableRow: {
        root: {
            '& > td:nth-child(1)': {
                width: '17%',
                minWidth: 100
            },
            '& > td:nth-child(2)': {
                width: '67%',
                fontSize: theme.typography.fontSize,
            },
            '& > td:nth-child(3)': {
                width: '16%'
            }
        }
    },
    MuiMenuItem: {
        root: {
            fontSize: theme.typography.fontSize
        }
    }
};

export default theme;
